/**
 * Returns true when the point (lat, lng) falls inside any of the department's
 * exclusion shapes. The circle, rectangle and ray-cast polygon tests are the
 * ones the permit form has always used, moved out of the component so the
 * address step can stay readable.
 */
export function isInRestrictedArea(lat, lng, shapes) {
    const { circleCoords = [], rectangleCoords = [], polygonCoords = [] } = shapes;

    const inCircle = circleCoords.some((coord) => {
        const circleRadiusInDegree = (coord.radius / 1.11) * 0.00001;
        const xDifference = Math.abs(lng - coord.coords.lng);
        const yDifference = Math.abs(lat - coord.coords.lat);
        const pointRadius = Math.sqrt(xDifference * xDifference + yDifference * yDifference);
        return circleRadiusInDegree > pointRadius;
    });

    const inRectangle = rectangleCoords.some(
        (coord) =>
            coord.coords[2].lat > lat &&
            coord.coords[0].lat < lat &&
            coord.coords[2].lng > lng &&
            coord.coords[0].lng < lng
    );

    const inPolygon = polygonCoords.some((coord) => {
        const points = coord.coords;
        // Does the edge a->b cross the horizontal ray cast east from the point?
        const crossesEastOfPoint = (a, b) => {
            if ((a.lat > lat && b.lat < lat) || (a.lat < lat && b.lat > lat)) {
                const slope = (b.lat - a.lat) / (b.lng - a.lng);
                const intercept = b.lat - slope * b.lng;
                const cross = (lat - intercept) / slope;
                return cross > lng;
            }
            return false;
        };

        let count = 0;
        if (crossesEastOfPoint(points[0], points[points.length - 1])) {
            count += 1;
        }
        for (let i = 0; i < points.length - 1; i++) {
            if (crossesEastOfPoint(points[i], points[i + 1])) {
                count += 1;
            }
        }
        return count % 2 === 1;
    });

    return inCircle || inRectangle || inPolygon;
}
